import { cn } from "@etudescarre/ui";
import { isNotNil } from "@etudescarre/utils";
import {
  FileArrowDown as FileArrowDownIcon,
  FilePdf as FilePdfIcon,
  Seal as SealIcon,
} from "@phosphor-icons/react";
import type { VersionData } from "./types";

export type VersionCellProps = {
  version: VersionData;
  onViewPdf: (fichierPdfId: number) => void;
  onDownloadNative: (fichierNativeId: number) => void;
  onMarkBpe: (versionId: number) => void;
  canMarkBpe: boolean;
};

export function VersionCell({
  version,
  onViewPdf,
  onDownloadNative,
  onMarkBpe,
  canMarkBpe,
}: VersionCellProps) {
  return (
    <div className="flex items-center gap-1.5">
      {/* PDF icon */}
      {version.hasPdf && isNotNil(version.fichierPdfId) ? (
        <button
          type="button"
          onClick={() => {
            const id = version.fichierPdfId;
            if (isNotNil(id)) onViewPdf(id);
          }}
          className="text-red-600 hover:text-red-700 dark:text-red-400"
          title="Voir le PDF"
        >
          <FilePdfIcon size={18} weight="fill" />
        </button>
      ) : (
        <span className="w-[18px]" />
      )}

      {/* Native file icon */}
      {version.hasNative && isNotNil(version.fichierNativeId) ? (
        <button
          type="button"
          onClick={() => {
            const id = version.fichierNativeId;
            if (isNotNil(id)) onDownloadNative(id);
          }}
          className="text-blue-600 hover:text-blue-700 dark:text-blue-400"
          title="Télécharger le fichier natif"
        >
          <FileArrowDownIcon size={18} />
        </button>
      ) : (
        <span className="w-[18px]" />
      )}

      {/* BPE indicator */}
      <button
        type="button"
        onClick={() => {
          if (canMarkBpe && !version.bpe) {
            onMarkBpe(version.id);
          }
        }}
        disabled={!canMarkBpe || version.bpe}
        className={cn(
          "relative",
          version.bpe
            ? "text-green-600 dark:text-green-400 cursor-default"
            : canMarkBpe
              ? "text-zinc-300 hover:text-green-500 dark:text-zinc-600 dark:hover:text-green-400 cursor-pointer"
              : "text-zinc-200 dark:text-zinc-700 cursor-default",
        )}
        title={
          version.bpe
            ? `BPE par ${version.bpeTagAuthor?.firstName ?? ""} ${version.bpeTagAuthor?.lastName ?? ""} le ${version.bpeTagCreatedAt ? new Date(version.bpeTagCreatedAt).toLocaleDateString("fr-FR") : ""}`
            : canMarkBpe
              ? "Marquer BPE"
              : ""
        }
      >
        <SealIcon size={18} weight={version.bpe ? "fill" : "regular"} />
      </button>
    </div>
  );
}
